import { ApiError } from '@/lib/api';

export const KYC_NO_ACCESS = "No access to this contact's KYC";

export const isKycDenied = (e: unknown) =>
  e instanceof ApiError && e.status === 403;
